import React from 'react'
import { get } from 'lodash';
import Cookies from 'js-cookie';
import store from '~/redux/user/store'
import { createOrderAndCustomer } from "~/services/juspayService";
import "~/components/JusPay/style.scss";
import Spinner from '~/components/Spinner';

class JusPay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      promoCode: ''
    }
  }

  componentDidMount() {
    const plan = this.props && this.props.plan;
    if(localStorage.getItem('user')){
      const userInfo = JSON.parse(localStorage.getItem('user'))
      if(userInfo && userInfo.user && userInfo.user.phoneNumber){
          this.phoneInputEl.value=userInfo.user.phoneNumber;
      }
    }
    
    if (plan) {
      Cookies.set('plan', plan);
    }
  }
  
  componentWillReceiveProps(nextProps) {
        
    if (this.props !== nextProps &&  get(nextProps.firstPayment, 'appliedOfferCode') && get(this.props.firstPayment, 'amount') !== get(nextProps.firstPayment, 'amount')) {

      let plan = this.props && this.props.plan;
      plan.promoCode = nextProps.firstPayment;
      this.setState({promoCode:nextProps.firstPayment});

      if (plan) {
        Cookies.set('plan', plan);
      }      
    } else if (this.props !== nextProps &&  get(this.props.firstPayment, 'amount') !== get(nextProps.firstPayment, 'amount')) { // for preapplied offer code.

      let plan = this.props && this.props.plan;
      plan.planDetails[0].recurringPaymentAmount = nextProps.firstPayment.amount;

      if (plan) {
        Cookies.set('plan', plan);
      }           
    }
  }

  getVal(key) {
    return get(this.props.metadataMap, key)
  }

  customerOrderCreattion = (event) => {
    event.preventDefault();
    const phoneNumber = this.phoneInputEl.value
    this.isOTPEnabled = get(window.settings, 'features.otp_value.otp_enabled');

    if(!this.isOTPEnabled){
      if (!Number(phoneNumber) || phoneNumber.length !== 10)
      return this.alert(this.getVal('ccaPhoneError'))
    }

    const plan = this.props.plan;
    const user = store.getState().user;
    const pd = plan.planDetails[0];
    this.setState({ processing: true });
    let appliedOfferCode = '';
              
    if(this.state.promoCode) {
      appliedOfferCode = get(this.state.promoCode, 'appliedOfferCode');
    }

    return createOrderAndCustomer(
          user.email,
          user.name,
          plan.id,
          plan.identifier,
          pd.countryCode,
          pd.recurringPaymentCurrencyCode,
          phoneNumber, 
          appliedOfferCode
        )
        .then(orderCreate => {
          const orderCreateResponse = orderCreate && orderCreate.data ? orderCreate.data : orderCreate;

          if ((orderCreate && orderCreate.status === 200)) {
            
            const order_id = orderCreateResponse.subscriptionInfo.paymentHandlerResponse.order_id;
            
            if (order_id) {
              Cookies.set('order_id', order_id);
            }

            window.location.href = "/juspay-payment";
            return false;
          } else {
            this.setState({ processing: false });
            this.alert((orderCreateResponse && orderCreateResponse.error_message) || "There is some issue. Please try again");
          }
        })
        .catch(e => {
          this.setState({ processing: false });
          this.alert(
            (e && e.message) || (e && e.error_message) || this.getVal("ccaProcessingError")
          );                  
        });
  }

  render() {
    return (
      <React.Fragment>
      {(this.state.processing === true) && <div className="loading-centered"><Spinner /></div>}
      <div className="juspay ccav-form">
        <h3 className="title">
          {this.getVal('ccaHeading')}
        </h3>
        <input
          type="text"
          className="phone-number-input"
          ref={el => this.phoneInputEl = el}
          placeholder={this.getVal('ccaPhone')}
          defaultValue=""
        />
        {this.state.error && <div className="error">
          {this.state.error}
        </div>}

        <div
          className={`button fat cta` + (this.state.processing ? ' processing' : '')}
          onClick={(event) => this.customerOrderCreattion(event)} >
          {this.getVal('ccaCheckout')}
        </div>

        <p className="warning">{this.getVal('ccaWarning')}</p>
      </div>
      </React.Fragment>
    )
  }


  alert(msg) {
    this.setState({ error: msg })
    setTimeout(_ => this.setState({ error: null }), 10000)
  }
}

export default JusPay
